import React, { createContext, useMemo } from 'react'
import PropTypes from 'prop-types'

export const CheckoutContext = createContext(null)

export const CheckoutProvider = ({ children, braintreeClientToken }) => {
  const value = useMemo(() => ({ braintreeClientToken }), [braintreeClientToken])
  return (
    <CheckoutContext.Provider value={value}>
      {children}
    </CheckoutContext.Provider>
  )
}

CheckoutProvider.propTypes = {
  children: PropTypes.node.isRequired,
  braintreeClientToken: PropTypes.string.isRequired,
}
